import React, { useEffect, useState } from 'react'
import PublicCatalogLayout from '../layouts/PublicCatalogLayout'
import OrderForm from './form/OrderForm'
const OrderEditPage = (props) => {
  const { user, order } = props
  const isEditing = order.raw == false
  return (
    <PublicCatalogLayout
      {...props}
      groups={[]}
      currentPage="orders_index"
      classNames={{body: 'white-background'}}
      breadcrumbs={[
        {name: "Orders", url: "/orders"},
        {name: isEditing ? `Order ${order.id}` : "New Order"}
      ]}
    >
      
      <div>
        <h1 class="catalog-h1">
          {isEditing ? `Order ${order.id}` : "New Order"}
        </h1>
      </div>
      <OrderForm order={order} user={user} />
    </PublicCatalogLayout>
  )
}

export default OrderEditPage